const baseUrl = "/v1/admin/setting/homepage";

export const apiUrls = {
  details: `${baseUrl}`,
  update: `${baseUrl}`,
};
